export default "__VITE_ASSET__DghlDbYE__"